
import React from "react"
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Person } from "../images/person.svg";
import { ReactComponent as Login } from "../images/login.svg";
import Button from '@mui/material/Button';
import Logo from './../images/luxinhotel_logo.svg'
import { styled, useTheme } from '@mui/material/styles';
import sty from "styled-components";
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { ThemeProvider, createTheme } from '@mui/material/styles';
const drawerWidth = 200;
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(1),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: drawerWidth,
        position: 'relative',
    variants: [
      {
        props: ({ open }) => open,
        style: {
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginRight: 0,
        },
      },
    ],
  }),
);
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
    width:200,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        width: 200,//`calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: drawerWidth,
      },
    },
  ],
}));
const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'right',
  width:50,
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
  },
});


// export default function MyAppBar(props) {
//   const theme = useTheme();
//   let navigate = useNavigate();
//   const [open, setOpen] = React.useState(false);
//   const handleDrawerOpen = () => {
//     setOpen(true);
//   };

//   const handleDrawerClose = () => {
//     setOpen(false);
//   };
//   const handleItem = (t, i) => {
//     switch (i) {
//       case 0:
//      //   setOpen(false);
//         navigate("/HotelVoucher");
//         break;
//       case 1:
//         navigate("/HotelInvoice");
//         break;
//       default:
//         break;
//     }
//   }
//   const handleItem2 = (t, i) => {
//     switch (i) {
//       case 0:
//      //   setOpen(false);
//        props.zannumb(true);
//          break;
//       // case 1:
//       //   navigate("/HotelInvoice");
//       //   break;
//       default:
//         break;
//     }
//   }
//   return (

//     <Box sx={{  backgroundColor: "black",width:'50px',float:'right' , direction:'rtl'}}>
    
//       {/* <CssBaseline /> */}
//       <ThemeProvider theme={darkTheme}>
//         <AppBar position="sticky"  open={open} sx={{ top: 'auto', bottom: 0 }}>
//           <Toolbar style={{display:'flex', justifyContent:"space-between"}}>
//             {/* <Typography variant="h6" noWrap sx={{ flexGrow: 1 }} component="div">
//               Persistent drawer
//             </Typography> */}
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               edge="end"
//               onClick={handleDrawerOpen}
//               sx={[open && { display: 'none' }]}
//             >
//               <MenuIcon />
//             </IconButton>
//           </Toolbar>
//         </AppBar>
//       </ThemeProvider>
//       <Main open={open}>
//         <DrawerHeader />
//         <Typography sx={{ marginBottom: 2 }}>

//         </Typography>
//         <Typography sx={{ marginBottom: 2 }}>

//         </Typography>
//       </Main>
//       <Drawer
//         sx={{
//           width: drawerWidth,
//             flexShrink: 0,
//             backgroundColor:'#F2F2F2',
//           '& .MuiDrawer-paper': {
//             width: drawerWidth,
//           },
//         }}
     
//         variant="persistent"
//         anchor="right"
//         open={open}
//       >
//         <DrawerHeader  sx={{backgroundColor:'#F2F2F2'}}>
//           <IconButton onClick={handleDrawerClose}>
//             {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
//           </IconButton>
//         </DrawerHeader>
//         <Divider />
//         <List  sx={{backgroundColor:'#F2F2F2'}}>
//           {['Voucher', 'Invooice', '--------', '--------'].map((text, index) => (
//             <ListItem key={text} >
//               <ListItemButton
//               disabled={(text=='Invooice' && localStorage.getItem('Reserv_Id')==='0') ? true : false}
//                 onClick={() => handleItem(text, index)}>
//                 <ListItemIcon>
//                   {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//                 </ListItemIcon>
//                 <ListItemText primary={text} />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>
//         <Divider />
//         <List  sx={{backgroundColor:'#F2F2F2'}}>
//           {['Setting Room', '--------', '--------'].map((text, index) => (
//             <ListItem key={text} disabled={true}>
//               <ListItemButton
//               onClick={() => handleItem2(text, index)}>
//                 <ListItemIcon>
//                   {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//                 </ListItemIcon>
//                 <ListItemText primary={text} />
//               </ListItemButton>
            
//             </ListItem>
//           ))}
//         </List>
//       </Drawer>

//      </Box>

//   )
// }
export default function MyAppBar() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    // <Box sx={{ display: 'flex' }}>
    //   <CssBaseline />
    <>
      <AppBar   >
        <Toolbar>
          <Typography variant="h6"  sx={{ flexGrow: 1 }} component="div">
          
          </Typography>
          <IconButton
            color="inherit"
         //   aria-label="open drawer"
         //   edge="end"
         //   onClick={handleDrawerOpen}
          //  sx={[open && { display: 'none' }]}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      {/* <Main open={open}>
        <DrawerHeader />

      </Main>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
          },
        }}
        variant="persistent"
        anchor="right"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          {['All mail', 'Trash', 'Spam'].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer> */}
      </>
    // </Box>
  );
}